import React from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon } from 'lucide-react';
const NavigationHeader = () => {
  return <header className="w-full bg-white shadow-sm" data-id="element-25">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center" data-id="element-26">
        <Link to="/" className="flex items-center" data-id="element-27">
          <h1 className="text-2xl font-bold text-teal-600" data-id="element-28">beautii.co</h1>
        </Link>
        <nav className="hidden md:flex space-x-8" data-id="element-29">
          <Link to="/" className="text-gray-700 hover:text-teal-600 font-medium" data-id="element-30">
            Home
          </Link>
          <Link to="/services" className="text-gray-700 hover:text-teal-600 font-medium" data-id="element-31">
            Services
          </Link>
          <a href="#" className="text-gray-700 hover:text-teal-600 font-medium" data-id="element-32">
            About
          </a>
          <a href="#" className="text-gray-700 hover:text-teal-600 font-medium" data-id="element-33">
            Contact
          </a>
        </nav>
        <div className="md:hidden" data-id="element-34">
          <button className="p-2" data-id="element-35">
            <MenuIcon className="h-6 w-6 text-gray-700" data-id="element-36" />
          </button>
        </div>
      </div>
    </header>;
};
export default NavigationHeader;